<template>
  <main>
    <LoadingSpinner v-if="!cotizacion" />
    <div class="container my-4" v-else>
      <div class="d-flex align-items-center justify-content-center">
        <ArgonButton
          v-if="!cotizacion.aprobada"
          class="mb-4 mt-2"
          color="dark"
          size="lg"
          @click="showModal('staticBackdrop')"
        >
          Aprobar cotización
        </ArgonButton>
        <ArgonAlert v-else>
          La cotización #{{ cotizacion.id }} ya ha sido aprobada.
        </ArgonAlert>
      </div>
      <iframe
        :src="`${urlEndpoint}public/cotizaciones/unidad/${token}/preview#toolbar=0`"
        title="PDF embebido"
        allowfullscreen
        class="w-100 border rounded"
        style="height: 95vh"
      ></iframe>

      <!-- Modal -->
      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="staticBackdropLabel">
                Confirmar plazo
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="plazo">Plazo</label>
                <select
                  name="plazo"
                  id="plazo"
                  class="form-control"
                  v-model="state.plazo"
                >
                  <option
                    :value="detalle.plazo"
                    v-for="detalle in cotizacionDetalle"
                    :key="detalle"
                  >
                    {{ detalle.plazo }} meses
                  </option>
                </select>
              </div>
            </div>
            <div class="table-responsive container">
              <table
                class="table table-sm table-striped table align-items-center mb-0 text-sm"
              >
                <tbody>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Tipo de equipo
                    </th>
                    <td>{{ cotizacion.arrendamiento }}</td>
                  </tr>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Descripción
                    </th>
                    <td>{{ cotizacion.descripcion }}</td>
                  </tr>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Valor del bien
                    </th>
                    <td>${{ formatoMoneda(cotizacion.valor, false) }}</td>
                  </tr>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Pago inicial
                    </th>
                    <td>${{ formatoMoneda(cotizacion.anticipo, false) }}</td>
                  </tr>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Renta
                    </th>
                    <td>
                      ${{ formatoMoneda(plazoSeleccionado.renta, false) }}
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Opción de compra
                    </th>
                    <td>
                      ${{ formatoMoneda(plazoSeleccionado.residual, false) }}
                    </td>
                  </tr>
                  <tr v-if="cotizacion.seguro_financiado == 1">
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Seguro mensual
                    </th>
                    <td>
                      {{
                        cotizacion.seguro_financiado == 1
                          ? "$" +
                            formatoMoneda(
                              plazoSeleccionado.seguro_mensual,
                              false
                            )
                          : ""
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <ArgonButton
                type="button"
                color="dark"
                size="sm"
                class="btn btn-primary"
                @click="aprobar"
                :loading="cargando"
              >
                Aprobar
              </ArgonButton>
              <ArgonButton
                color="light"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                size="sm"
              >
                Cerrar
              </ArgonButton>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="modalRedirigir"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body text-center">
              <h4>La cotización #{{ cotizacion.id }} ha sido aprobada.</h4>
              <p class="text-lg">
                En breve estarás siendo redirigido hacia nuestra plataforma para
                que pre apruebes tu línea de crédito.<br />
                Gracias.
              </p>
            </div>
            <div
              class="modal-footer d-flex flex-row align-items-center justify-content-center"
            >
              <a
                href="https://ventus.mx/pre-aprueba-tu-linea-paso-1-crea-tu-cuenta-o-inicia-sesion/"
                target="_blank"
                class="btn btn-primary"
              >
                Aceptar
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import LoadingSpinner from "@/components/LoadingComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import { useCotizacionUnidad } from "@/composables/useCotizacionUnidad";
import useUtil from "@/composables/useUtil";
import appApi from "@/services/api";
import { cotizacionUnidadHistorialService } from "@/services/cotizacion-unidad.service";
import { exceptionRequestMsg } from "@/assets/js/util";

const { formatoMoneda } = useUtil();
const cargando = ref(false);

const {
  getById,
  cotizacion,
  agente,
  cotizacionDetalle,
} = useCotizacionUnidad();

const state = ref({
  plazo: undefined,
});

const showModal = (modalId) => {
  const myModal = new bootstrap.Modal(document.getElementById(modalId));

  myModal.show();
};

const urlEndpoint = ref(null);
urlEndpoint.value =
  process.env.VUE_APP_ENV == "production"
    ? process.env.VUE_APP_ENDPOINT_SERVER
    : process.env.VUE_APP_ENDPOINT_LOCAL;

const route = useRoute();
const token = ref(undefined);

token.value = route.params.token;

const plazoSeleccionado = computed(() => {
  if (cotizacionDetalle.value.length == 0) return undefined;

  return cotizacionDetalle.value.filter(
    (detalle) => detalle.plazo == state.value.plazo
  )[0];
});

const aprobar = async () => {
  cargando.value = true;
  try {
    const response = await cotizacionUnidadHistorialService.aprobar(
      route.params.token,
      {
        plazo: plazoSeleccionado.value.plazo,
      }
    );
    await getById();

    const modalElement = document.getElementById("staticBackdrop");
    const modalInstance = bootstrap.Modal.getInstance(modalElement);
    if (modalInstance) {
      modalInstance.hide();
    }
    showModal("modalRedirigir");
  } catch (error) {
    console.error(error);
    return exceptionRequestMsg(error);
  } finally {
    cargando.value = false;
  }
};

onMounted(async () => {
  await getById();
  state.value.plazo = cotizacionDetalle.value[0].plazo;
});
</script>
